import React from 'react';
import AdsManager from './AdsManager.js';
import AgreementsEditor from './AgreementsEditor.js';
import Announcements from './Announcements.js';
import CountryEditor from './CountryEditor.js';
import Maintenance from './Maintenance.js';
import ListingsEditor from './ListingsEditor.js';
import MenuEditor from './MenuEditor.js';
import SmartSearchEditor from './SmartSearchEditor.js';
import SocialMediaEditor from './SocialMediaEditor.js';
import TypesEditor from './TypesEditor.js';
import Users from './Users.js';
import { Link, useNavigate } from 'react-router-dom';

import './Admin.css';

//revision 20240422

function Admin({ state, setState }) {
    const history = useNavigate();

    const handleAdsManager = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AdsManager state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Ads Manager' }))
    }
    const handleAgreementsEditor = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AgreementsEditor state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Agreements Editor' }))
    }
    const handleAnnouncements = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Announcements state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Announcements' }))
    }
    const handleCountryEditor = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <CountryEditor state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Country Editor' }))
    }
    const handleMaintenance = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Maintenance state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Maintenance' }))
    }
    const handleListingsEditor = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ListingsEditor state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Listings Editor' }))
    }
    const handleMenuEditor = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <MenuEditor state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Menu Editor' }))
    }
    const handleSmartSearchEditor = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <SmartSearchEditor state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Smart Search Editor' }))
    }
    const handleSocialMediaEditor = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <SocialMediaEditor state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Social Media Editor' }))
    }
    const handleTypesEditor = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <TypesEditor state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Types Editor' }))
    }
    const handleUsers = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Users state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Users' }))
    }
    const handleCRM = () => {
        history('/crm')
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: '', modaltitle: '' }))
    }

    return (
        <div className='admin'>
            <div className="admin_item" onClick={handleAdsManager}>Ads Manager</div>
            <div className="admin_item" onClick={handleAgreementsEditor}>Agreements Editor</div>
            <div className="admin_item" onClick={handleAnnouncements}>Announcements</div>
            <div className="admin_item" onClick={handleCountryEditor}>Country Editor</div>
            <div className="admin_item" onClick={handleMaintenance}>Maintenance</div>
            <div className="admin_item" onClick={handleListingsEditor}>Listings Editor</div>
            <div className="admin_item" onClick={handleMenuEditor}>Menu Editor</div>
            <div className="admin_item" onClick={handleSmartSearchEditor}>Smart Search Editor</div>
            <div className="admin_item" onClick={handleSocialMediaEditor}>Social Media Editor</div>
            <div className="admin_item" onClick={handleTypesEditor}>Types Editor</div>
            <div className="admin_item" onClick={handleUsers}>Users</div>
            <div className="admin_item" onClick={handleCRM}>CRM</div>
        </div>
    );
};

export default Admin;